export const getElementWidth = (element, defaultValue = 0) => element?.getBoundingClientRect().width || defaultValue;
